<canvas style="width: 100%" #canvas [id]="chartId">{{ chart }}</canvas>
